import Billing from './billing';
import Buttons from './buttons';
import Company from './company';
import Contract from './contract';
import Dashboard from './dashboard';
import Filters from './filters';
import Form from './form';
import ImageCropper from './image-cropper/ImageCropperIndex';
import Layout from './layout';
import Locations from './locations';
import LoyaltyProgram from './loyalty-program';
import LoyaltyStats from './loyalty-stats';
import Marketing from './marketing';
import Menu from './menu';
import Onboarding from './onboarding';
import OpeningHours from './opening-hours';
import OrderSettings from './order-settings';
import Payments from './payments';
import PDF from './pdf';
import PlatformAgent from './platform-agent';
import ProcessingFees from './processing-fees';
import PromoCode from './promo-code';
import ProviderBilling from './provider-billing';
import Reservations from './reservations';
import Schedule from './schedule';
import ServiceFee from './service-fee';
import ScheduleExceptions from './schedule-exceptions';
import Subscription from './subscription';
import Takeout from './takeout';
import Tax from './tax';
import Team from './team';
import Verification from './verification';
import DocumentSlots from './document-slots';
import ClickToCopy from './ClickToCopy';
import Modals from './modals';
import MobileApp from './mobile-app';
import DnsRecords from './dns-records';
import PartnerDomain from './partner-domain';
import PartnerShopDomain from './partner-shop-domain';
import RestaurantDomain from './restaurant-domain';
import HostAccess from './host-access';

export default {
  Billing,
  Buttons,
  Company,
  Contract,
  Dashboard,
  Filters,
  Form,
  ImageCropper,
  Layout,
  Locations,
  LoyaltyProgram,
  LoyaltyStats,
  Marketing,
  Menu,
  Onboarding,
  OpeningHours,
  OrderSettings,
  Payments,
  PDF,
  PlatformAgent,
  ProcessingFees,
  PromoCode,
  ProviderBilling,
  Reservations,
  Schedule,
  ServiceFee,
  ScheduleExceptions,
  Subscription,
  Takeout,
  Tax,
  Team,
  Verification,
  DocumentSlots,
  ClickToCopy,
  Modals,
  MobileApp,
  DnsRecords,
  PartnerDomain,
  PartnerShopDomain,
  RestaurantDomain,
  HostAccess,
};
